const palette = {
  black: {
    default: "#242a30",
    black001: "#fdfdfd",
    black002: "#fbfbfb",
    black003: "#f8f9f9",
    black004: "#f6f6f7",
    black005: "#f4f4f5",
    black006: "#f2f2f3",
    black007: "#f0f0f1",
    black008: "#edeeee",
    black009: "#ebecec",
    black010: "#e9eaea",
    black012: "#e5e5e6",
    black016: "#dcddde",
    black024: "#cacccd",
    black032: "#b9bbbd",
    black040: "#a7aaac",
    black048: "#96999c",
    black056: "#84888b",
    black064: "#73777b",
    black072: "#61666a",
    black080: "#505559",
    black088: "#3e4449",
    black096: "#2d3338",
    blackAlpha001: "rgba(36, 42, 48, 0.01)",
    blackAlpha002: "rgba(36, 42, 48, 0.02)",
    blackAlpha003: "rgba(36, 42, 48, 0.03)",
    blackAlpha004: "rgba(36, 42, 48, 0.04)",
    blackAlpha005: "rgba(36, 42, 48, 0.05)",
    blackAlpha006: "rgba(36, 42, 48, 0.06)",
    blackAlpha007: "rgba(36, 42, 48, 0.07)",
    blackAlpha008: "rgba(36, 42, 48, 0.08)",
    blackAlpha009: "rgba(36, 42, 48, 0.09)",
    blackAlpha010: "rgba(36, 42, 48, 0.1)",
    blackAlpha012: "rgba(36, 42, 48, 0.12)",
    blackAlpha016: "rgba(36, 42, 48, 0.16)",
    blackAlpha020: "rgba(36, 42, 48, 0.2)",
    blackAlpha024: "rgba(36, 42, 48, 0.24)",
    blackAlpha032: "rgba(36, 42, 48, 0.32)",
    blackAlpha040: "rgba(36, 42, 48, 0.4)",
    blackAlpha048: "rgba(36, 42, 48, 0.48)",
    blackAlpha056: "rgba(36, 42, 48, 0.56)",
    blackAlpha064: "rgba(36, 42, 48, 0.64)",
    blackAlpha072: "rgba(36, 42, 48, 0.72)",
    blackAlpha080: "rgba(36, 42, 48, 0.8)",
    blackAlpha088: "rgba(36, 42, 48, 0.88)",
    blackAlpha096: "rgba(36, 42, 48, 0.96)"
  },
  gradient: {
    flame: "linear-gradient(96.77deg, #f96a19 -0.96%, #fb60bd 100%)",
    magic: "linear-gradient(96.77deg, #9d3cff -0.96%, #6066ff 100%)",
    mango: "linear-gradient(96.77deg, #fa9e00 -0.96%, #ff8e26 100%)",
    tropical: "linear-gradient(97deg, #09CD07 0%, #0BC409 14%, #06C8BB 88%)"
  },
  yellow: {
    light: "#ffd454",
    dark: "#b57700",
    darker: "#704300",
    lightest: "#fffcf2",
    default: "#fab300",
    lighter: "#ffeebd"
  },
  white: {
    default: "#ffffff",
    /** @deprecated use whiteAlpha001 */
    white001: "rgba(255, 255, 255, 0.01)",
    /** @deprecated use whiteAlpha002 */
    white002: "rgba(255, 255, 255, 0.02)",
    /** @deprecated use whiteAlpha003 */
    white003: "rgba(255, 255, 255, 0.03)",
    /** @deprecated use whiteAlpha004 */
    white004: "rgba(255, 255, 255, 0.04)",
    /** @deprecated use whiteAlpha005 */
    white005: "rgba(255, 255, 255, 0.05)",
    /** @deprecated use whiteAlpha006 */
    white006: "rgba(255, 255, 255, 0.06)",
    /** @deprecated use whiteAlpha007 */
    white007: "rgba(255, 255, 255, 0.07)",
    /** @deprecated use whiteAlpha008 */
    white008: "rgba(255, 255, 255, 0.08)",
    /** @deprecated use whiteAlpha009 */
    white009: "rgba(255, 255, 255, 0.09)",
    /** @deprecated use whiteAlpha010 */
    white010: "rgba(255, 255, 255, 0.1)",
    /** @deprecated use whiteAlpha012 */
    white012: "rgba(255, 255, 255, 0.12)",
    /** @deprecated use whiteAlpha016 */
    white016: "rgba(255, 255, 255, 0.16)",
    /** @deprecated use whiteAlpha020 */
    white020: "rgba(255, 255, 255, 0.2)",
    /** @deprecated use whiteAlpha024 */
    white024: "rgba(255, 255, 255, 0.24)",
    /** @deprecated use whiteAlpha028 */
    white028: "rgba(255, 255, 255, 0.28)",
    /** @deprecated use whiteAlpha032 */
    white032: "rgba(255, 255, 255, 0.32)",
    /** @deprecated use whiteAlpha040 */
    white040: "rgba(255, 255, 255, 0.4)",
    /** @deprecated use whiteAlpha048 */
    white048: "rgba(255, 255, 255, 0.48)",
    /** @deprecated use whiteAlpha056 */
    white056: "rgba(255, 255, 255, 0.56)",
    /** @deprecated use whiteAlpha064 */
    white064: "rgba(255, 255, 255, 0.64)",
    /** @deprecated use whiteAlpha072 */
    white072: "rgba(255, 255, 255, 0.72)",
    /** @deprecated use whiteAlpha080 */
    white080: "rgba(255, 255, 255, 0.8)",
    /** @deprecated use whiteAlpha088 */
    white088: "rgba(255, 255, 255, 0.88)",
    /** @deprecated use whiteAlpha096 */
    white096: "rgba(255, 255, 255, 0.96)",
    whiteAlpha001: "rgba(255, 255, 255, 0.01)",
    whiteAlpha002: "rgba(255, 255, 255, 0.02)",
    whiteAlpha003: "rgba(255, 255, 255, 0.03)",
    whiteAlpha004: "rgba(255, 255, 255, 0.04)",
    whiteAlpha005: "rgba(255, 255, 255, 0.05)",
    whiteAlpha006: "rgba(255, 255, 255, 0.06)",
    whiteAlpha007: "rgba(255, 255, 255, 0.07)",
    whiteAlpha008: "rgba(255, 255, 255, 0.08)",
    whiteAlpha009: "rgba(255, 255, 255, 0.09)",
    whiteAlpha010: "rgba(255, 255, 255, 0.1)",
    whiteAlpha012: "rgba(255, 255, 255, 0.12)",
    whiteAlpha016: "rgba(255, 255, 255, 0.16)",
    whiteAlpha020: "rgba(255, 255, 255, 0.2)",
    whiteAlpha024: "rgba(255, 255, 255, 0.24)",
    whiteAlpha028: "rgba(255, 255, 255, 0.28)",
    whiteAlpha032: "rgba(255, 255, 255, 0.32)",
    whiteAlpha040: "rgba(255, 255, 255, 0.4)",
    whiteAlpha048: "rgba(255, 255, 255, 0.48)",
    whiteAlpha056: "rgba(255, 255, 255, 0.56)",
    whiteAlpha064: "rgba(255, 255, 255, 0.64)",
    whiteAlpha072: "rgba(255, 255, 255, 0.72)",
    whiteAlpha080: "rgba(255, 255, 255, 0.8)",
    whiteAlpha088: "rgba(255, 255, 255, 0.88)",
    whiteAlpha096: "rgba(255, 255, 255, 0.96)"
  },
  purple: {
    light: "#aa7ad9",
    darker: "#361853",
    dark: "#5b288d",
    default: "#8f40de",
    lightest: "#faf5ff",
    lighter: "#ddcced"
  },
  magenta: {
    light: "#f584ad",
    darker: "#651e38",
    dark: "#aa325e",
    default: "#f04785",
    lighter: "#facddd",
    lightest: "#fef6f9"
  },
  green: {
    lighter: "#b7e8bd",
    light: "#59cd65",
    darker: "#034c0b",
    dark: "#058012",
    lightest: "#f6fdf7",
    default: "#09bb1b"
  },
  gray: {
    light: "#96999c",
    darker: "#242a30",
    dark: "#3e4449",
    default: "#61666a",
    lighter: "#cacccd",
    lightest: "#f8f9f9"
  },
  gold: {
    light: "#d6a754",
    darker: "#513400",
    dark: "#8a5700",
    lighter: "#ecd8b6",
    lightest: "#fcfbf7",
    default: "#cf7800"
  },
  cyan: {
    lighter: "#b4edec",
    darker: "#005352",
    light: "#55d9d7",
    default: "#01c6c3",
    lightest: "#f2fdfd",
    dark: "#03706e"
  },
  blue: {
    light: "#54a6ee",
    lighter: "#c2e3ff",
    lightest: "#f5fbff",
    dark: "#1545a1",
    default: "#2161dc",
    darker: "#102a5c"
  },
  primary: {
    darker: "#034c0b",
    dark: "#058012",
    light: "#59cd65",
    default: "#09bb1b",
    lightest: "#f2fdf3",
    lighter: "#b7e8bd"
  },
  background: {
    default: "#fdfdfd"
  },
  orange: {
    darker: "#661400",
    default: "#f24b17",
    dark: "#c32700",
    light: "#f57453",
    lighter: "#ffcec2",
    lightest: "#fff7f5"
  },
  cosmicBlue: {
    default: "#3b86c8",
    lighter: "#c5dff2",
    light: "#70afdb",
    dark: "#1c5992",
    lightest: "#f6fbfe",
    darker: "#0f3457"
  }
};
const colors = {
  black: "#242a30",
  black001: "#fdfdfd",
  black002: "#fbfbfb",
  black003: "#f8f9f9",
  black004: "#f6f6f7",
  black005: "#f4f4f5",
  black006: "#f2f2f3",
  black007: "#f0f0f1",
  black008: "#edeeee",
  black009: "#ebecec",
  black010: "#e9eaea",
  black012: "#e5e5e6",
  black016: "#dcddde",
  black024: "#cacccd",
  black032: "#b9bbbd",
  black040: "#a7aaac",
  black048: "#96999c",
  black056: "#84888b",
  black064: "#73777b",
  black072: "#61666a",
  black080: "#505559",
  black088: "#3e4449",
  black096: "#2d3338",
  blackAlpha001: "rgba(36, 42, 48, 0.01)",
  blackAlpha002: "rgba(36, 42, 48, 0.02)",
  blackAlpha003: "rgba(36, 42, 48, 0.03)",
  blackAlpha004: "rgba(36, 42, 48, 0.04)",
  blackAlpha005: "rgba(36, 42, 48, 0.05)",
  blackAlpha006: "rgba(36, 42, 48, 0.06)",
  blackAlpha007: "rgba(36, 42, 48, 0.07)",
  blackAlpha008: "rgba(36, 42, 48, 0.08)",
  blackAlpha009: "rgba(36, 42, 48, 0.09)",
  blackAlpha010: "rgba(36, 42, 48, 0.1)",
  blackAlpha012: "rgba(36, 42, 48, 0.12)",
  blackAlpha016: "rgba(36, 42, 48, 0.16)",
  blackAlpha020: "rgba(36, 42, 48, 0.2)",
  blackAlpha024: "rgba(36, 42, 48, 0.24)",
  blackAlpha032: "rgba(36, 42, 48, 0.32)",
  blackAlpha040: "rgba(36, 42, 48, 0.4)",
  blackAlpha048: "rgba(36, 42, 48, 0.48)",
  blackAlpha056: "rgba(36, 42, 48, 0.56)",
  blackAlpha064: "rgba(36, 42, 48, 0.64)",
  blackAlpha072: "rgba(36, 42, 48, 0.72)",
  blackAlpha080: "rgba(36, 42, 48, 0.8)",
  blackAlpha088: "rgba(36, 42, 48, 0.88)",
  blackAlpha096: "rgba(36, 42, 48, 0.96)",
  flame: "linear-gradient(96.77deg, #f96a19 -0.96%, #fb60bd 100%)",
  magic: "linear-gradient(96.77deg, #9d3cff -0.96%, #6066ff 100%)",
  mango: "linear-gradient(96.77deg, #fa9e00 -0.96%, #ff8e26 100%)",
  tropical: "linear-gradient(97deg, #09CD07 0%, #0BC409 14%, #06C8BB 88%)",
  yellowLight: "#ffd454",
  yellowDark: "#b57700",
  yellowDarker: "#704300",
  yellowLightest: "#fffcf2",
  yellow: "#fab300",
  yellowLighter: "#ffeebd",
  white: "#ffffff",
  /** @deprecated use whiteAlpha001 */
  white001: "rgba(255, 255, 255, 0.01)",
  /** @deprecated use whiteAlpha002 */
  white002: "rgba(255, 255, 255, 0.02)",
  /** @deprecated use whiteAlpha003 */
  white003: "rgba(255, 255, 255, 0.03)",
  /** @deprecated use whiteAlpha004 */
  white004: "rgba(255, 255, 255, 0.04)",
  /** @deprecated use whiteAlpha005 */
  white005: "rgba(255, 255, 255, 0.05)",
  /** @deprecated use whiteAlpha006 */
  white006: "rgba(255, 255, 255, 0.06)",
  /** @deprecated use whiteAlpha007 */
  white007: "rgba(255, 255, 255, 0.07)",
  /** @deprecated use whiteAlpha008 */
  white008: "rgba(255, 255, 255, 0.08)",
  /** @deprecated use whiteAlpha009 */
  white009: "rgba(255, 255, 255, 0.09)",
  /** @deprecated use whiteAlpha010 */
  white010: "rgba(255, 255, 255, 0.1)",
  /** @deprecated use whiteAlpha012 */
  white012: "rgba(255, 255, 255, 0.12)",
  /** @deprecated use whiteAlpha016 */
  white016: "rgba(255, 255, 255, 0.16)",
  /** @deprecated use whiteAlpha020 */
  white020: "rgba(255, 255, 255, 0.2)",
  /** @deprecated use whiteAlpha024 */
  white024: "rgba(255, 255, 255, 0.24)",
  /** @deprecated use whiteAlpha028 */
  white028: "rgba(255, 255, 255, 0.28)",
  /** @deprecated use whiteAlpha032 */
  white032: "rgba(255, 255, 255, 0.32)",
  /** @deprecated use whiteAlpha040 */
  white040: "rgba(255, 255, 255, 0.4)",
  /** @deprecated use whiteAlpha048 */
  white048: "rgba(255, 255, 255, 0.48)",
  /** @deprecated use whiteAlpha056 */
  white056: "rgba(255, 255, 255, 0.56)",
  /** @deprecated use whiteAlpha064 */
  white064: "rgba(255, 255, 255, 0.64)",
  /** @deprecated use whiteAlpha072 */
  white072: "rgba(255, 255, 255, 0.72)",
  /** @deprecated use whiteAlpha080 */
  white080: "rgba(255, 255, 255, 0.8)",
  /** @deprecated use whiteAlpha088 */
  white088: "rgba(255, 255, 255, 0.88)",
  /** @deprecated use whiteAlpha096 */
  white096: "rgba(255, 255, 255, 0.96)",
  whiteAlpha001: "rgba(255, 255, 255, 0.01)",
  whiteAlpha002: "rgba(255, 255, 255, 0.02)",
  whiteAlpha003: "rgba(255, 255, 255, 0.03)",
  whiteAlpha004: "rgba(255, 255, 255, 0.04)",
  whiteAlpha005: "rgba(255, 255, 255, 0.05)",
  whiteAlpha006: "rgba(255, 255, 255, 0.06)",
  whiteAlpha007: "rgba(255, 255, 255, 0.07)",
  whiteAlpha008: "rgba(255, 255, 255, 0.08)",
  whiteAlpha009: "rgba(255, 255, 255, 0.09)",
  whiteAlpha010: "rgba(255, 255, 255, 0.1)",
  whiteAlpha012: "rgba(255, 255, 255, 0.12)",
  whiteAlpha016: "rgba(255, 255, 255, 0.16)",
  whiteAlpha020: "rgba(255, 255, 255, 0.2)",
  whiteAlpha024: "rgba(255, 255, 255, 0.24)",
  whiteAlpha028: "rgba(255, 255, 255, 0.28)",
  whiteAlpha032: "rgba(255, 255, 255, 0.32)",
  whiteAlpha040: "rgba(255, 255, 255, 0.4)",
  whiteAlpha048: "rgba(255, 255, 255, 0.48)",
  whiteAlpha056: "rgba(255, 255, 255, 0.56)",
  whiteAlpha064: "rgba(255, 255, 255, 0.64)",
  whiteAlpha072: "rgba(255, 255, 255, 0.72)",
  whiteAlpha080: "rgba(255, 255, 255, 0.8)",
  whiteAlpha088: "rgba(255, 255, 255, 0.88)",
  whiteAlpha096: "rgba(255, 255, 255, 0.96)",
  purpleLight: "#aa7ad9",
  purpleDarker: "#361853",
  purpleDark: "#5b288d",
  purple: "#8f40de",
  purpleLightest: "#faf5ff",
  purpleLighter: "#ddcced",
  magentaLight: "#f584ad",
  magentaDarker: "#651e38",
  magentaDark: "#aa325e",
  magenta: "#f04785",
  magentaLighter: "#facddd",
  magentaLightest: "#fef6f9",
  greenLighter: "#b7e8bd",
  greenLight: "#59cd65",
  greenDarker: "#034c0b",
  greenDark: "#058012",
  greenLightest: "#f6fdf7",
  green: "#09bb1b",
  grayLight: "#96999c",
  grayDarker: "#242a30",
  grayDark: "#3e4449",
  gray: "#61666a",
  grayLighter: "#cacccd",
  grayLightest: "#f8f9f9",
  goldLight: "#d6a754",
  goldDarker: "#513400",
  goldDark: "#8a5700",
  goldLighter: "#ecd8b6",
  goldLightest: "#fcfbf7",
  gold: "#cf7800",
  cyanLighter: "#b4edec",
  cyanDarker: "#005352",
  cyanLight: "#55d9d7",
  cyan: "#01c6c3",
  cyanLightest: "#f2fdfd",
  cyanDark: "#03706e",
  blueLight: "#54a6ee",
  blueLighter: "#c2e3ff",
  blueLightest: "#f5fbff",
  blueDark: "#1545a1",
  blue: "#2161dc",
  blueDarker: "#102a5c",
  primaryDarker: "#034c0b",
  primaryDark: "#058012",
  primaryLight: "#59cd65",
  primary: "#09bb1b",
  primaryLightest: "#f2fdf3",
  primaryLighter: "#b7e8bd",
  background: "#fdfdfd",
  orangeDarker: "#661400",
  orange: "#f24b17",
  orangeDark: "#c32700",
  orangeLight: "#f57453",
  orangeLighter: "#ffcec2",
  orangeLightest: "#fff7f5",
  cosmicBlue: "#3b86c8",
  cosmicBlueLighter: "#c5dff2",
  cosmicBlueLight: "#70afdb",
  cosmicBlueDark: "#1c5992",
  cosmicBlueLightest: "#f6fbfe",
  cosmicBlueDarker: "#0f3457"
};

export { colors as default, palette };
//# sourceMappingURL=colors.mjs.map
